export default {
    props: {
        tooltipBackground: {
            type: String,
            default: undefined,
            kComposite: 'tooltip.background'
        }, 
        tooltipBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'tooltip.border.color'
        }, 
        tooltipBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'tooltip.border.width'
        }, 
        tooltipColor: {
            type: String,
            default: undefined,
            kComposite: 'tooltip.color'
        }, 
        tooltipFont: {
            type: String,
            default: undefined,
            kComposite: 'tooltip.font'
        }, 
        tooltipFormat: {
            type: String,
            default: undefined,
            kComposite: 'tooltip.format'
        }, 
        tooltipOpacity: {
            type: Number,
            default: undefined,
            kComposite: 'tooltip.opacity'
        }, 
        tooltipPadding: {
            type: Number,
            default: undefined,
            kComposite: 'tooltip.padding'
        }, 
        tooltipPaddingBottom: {
            type: Number,
            default: undefined,
            kComposite: 'tooltip.padding.bottom'
        }, 
        tooltipPaddingLeft: {
            type: Number,
            default: undefined,
            kComposite: 'tooltip.padding.left'
        }, 
        tooltipPaddingRight: {
            type: Number,
            default: undefined,
            kComposite: 'tooltip.padding.right'
        }, 
        tooltipPaddingTop: {
            type: Number,
            default: undefined,
            kComposite: 'tooltip.padding.top'
        }, 
        tooltipShared: {
            type: Boolean,
            default: undefined,
            kComposite: 'tooltip.shared'
        }, 
        tooltipSharedTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'tooltip.sharedTemplate'
        }, 
        tooltipTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'tooltip.template'
        }, 
        tooltipVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'tooltip.visible'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-charts-vue-wrapper/src/KendoChartBase/Tooltip.js